import { createContext } from 'react';

interface ILoginContext {
  email: string;
  setEmail: (email: string) => void;
}

export const LoginContext = createContext<ILoginContext>(null);

LoginContext.displayName = 'LoginContext';
